import { FlagIconType } from "../../Types/IconsType";

export const flagIconData: FlagIconType[] = [
    { abbreviation: 'in', name: 'India Flag' },
    { abbreviation: 'ad', name: 'Andorra Flag' },
    { abbreviation: 'ae', name: 'United Arab Emirates Flag' },
    { abbreviation: 'af', name: 'Afghanistan Flag' },
    { abbreviation: 'ag', name: 'Antigua and Barbuda Flag' },
    { abbreviation: 'ai', name: 'Anguilla Flag' },
    { abbreviation: 'al', name: 'Albania Flag' },
    { abbreviation: 'am', name: 'Armenia Flag' },
    { abbreviation: 'ao', name: 'Angola Flag' },
    { abbreviation: 'ar', name: 'Argentina Flag' },
    { abbreviation: 'as', name: 'American Samoa Flag' },
    { abbreviation: 'at', name: 'Austria Flag' },
    { abbreviation: 'au', name: 'Australia Flag' },
    { abbreviation: 'aw', name: 'Aruba Flag' },
    { abbreviation: 'ax', name: 'Aland Islands Flag' },
    { abbreviation: 'az', name: 'Azerbaijan Flag' },
    { abbreviation: 'ba', name: 'Bosnia and Herzegovina Flag' },
    { abbreviation: 'bb', name: 'Barbados Flag' },
    { abbreviation: 'bd', name: 'Bangladesh Flag' },
    { abbreviation: 'be', name: 'Belgium Flag' },
    { abbreviation: 'bf', name: 'Burkina Faso Flag' },
    { abbreviation: 'bg', name: 'Bulgaria Flag' },
    { abbreviation: 'bh', name: 'Bahrain Flag' },
    { abbreviation: 'bi', name: 'Burundi Flag' },
    { abbreviation: 'bj', name: 'Benin Flag' },
    { abbreviation: 'bl', name: 'Saint Barthélemy Flag' },
    { abbreviation: 'bm', name: 'Bermuda Flag' },
    { abbreviation: 'bn', name: 'Brunei Darussalam Flag' },
    { abbreviation: 'bo', name: 'Bolivia (Plurinational State of) Flag' },
    { abbreviation: 'bq', name: 'Bonaire, Sint Eustatius and Saba Flag' },
    { abbreviation: 'br', name: 'Brazil Flag' },
    { abbreviation: 'bs', name: 'Bahamas Flag' },
    { abbreviation: 'bt', name: 'Bhutan Flag' },
    { abbreviation: 'bw', name: 'Botswana Flag' },
    { abbreviation: 'by', name: 'Belarus Flag' },
    { abbreviation: 'bz', name: 'Belize Flag' },
    { abbreviation: 'ca', name: 'Canada Flag' },
    { abbreviation: 'cc', name: 'Cocos (Keeling) Islands Flag' },
    { abbreviation: 'cd', name: 'Democratic Republic of the Congo Flag' },
    { abbreviation: 'cf', name: 'Central African Republic Flag' },
    { abbreviation: 'cg', name: 'Republic of the Congo Flag' },
    { abbreviation: 'ch', name: 'Switzerland Flag' },
    { abbreviation: 'ci', name: 'Côte d Ivoire Flag' },
    { abbreviation: 'ck', name: 'Cook Islands Flag' },
    { abbreviation: 'cl', name: 'Chile Flag' },
    { abbreviation: 'cm', name: 'Cameroon Flag' },
    { abbreviation: 'cn', name: 'China Flag' },
    { abbreviation: 'co', name: 'Colombia Flag' },
    { abbreviation: 'cr', name: 'Costa Rica Flag' },
    { abbreviation: 'cu', name: 'Cuba Flag' },
    { abbreviation: 'cv', name: 'Cabo Verde Flag' },
    { abbreviation: 'cw', name: 'Curaçao Flag' },
    { abbreviation: 'cx', name: 'Christmas Island Flag' },
    { abbreviation: 'cy', name: 'Cyprus Flag' },
    { abbreviation: 'cz', name: 'Czech Republic Flag' },
    { abbreviation: 'de', name: 'Germany Flag' },
    { abbreviation: 'dj', name: 'Djibouti Flag' },
    { abbreviation: 'dk', name: 'Denmark Flag' },
    { abbreviation: 'dm', name: 'Dominica Flag' },
    { abbreviation: 'do', name: 'Dominican Republic Flag' },
    { abbreviation: 'dz', name: 'Algeria Flag' },
    { abbreviation: 'ec', name: 'Ecuador Flag' },
    { abbreviation: 'ee', name: 'Estonia Flag' },
    { abbreviation: 'eg', name: 'Egypt Flag' },
    { abbreviation: 'eh', name: 'Western Sahara Flag' },
    { abbreviation: 'er', name: 'Eritrea Flag' },
    { abbreviation: 'es', name: 'Spain Flag' },
    { abbreviation: 'et', name: 'Ethiopia Flag' },
    { abbreviation: 'fi', name: 'Finland Flag' },
    { abbreviation: 'fj', name: 'Fiji Flag' },
    { abbreviation: 'fk', name: 'Falkland Islands Flag' },
    { abbreviation: 'fm', name: 'Federated States of Micronesia Flag' },
    { abbreviation: 'fo', name: 'Faroe Islands Flag' },
    { abbreviation: 'fr', name: 'France Flag' },
    { abbreviation: 'ga', name: 'Gabon Flag' },
    { abbreviation: 'gb', name: 'United Kingdom Flag' },
    { abbreviation: 'gd', name: 'Grenada Flag' },
    { abbreviation: 'ge', name: 'Georgia Flag' },
    { abbreviation: 'gf', name: 'French Guiana Flag' },
    { abbreviation: 'gg', name: 'Guernsey Flag' },
    { abbreviation: 'gh', name: 'Ghana Flag' },
    { abbreviation: 'gi', name: 'Gibraltar Flag' },
    { abbreviation: 'gl', name: 'Greenland Flag' },
    { abbreviation: 'gm', name: 'Gambia Flag' },
    { abbreviation: 'gn', name: 'Guinea Flag' },
    { abbreviation: 'gp', name: 'Guadeloupe Flag' },
    { abbreviation: 'gq', name: 'Equatorial Guinea Flag' },
    { abbreviation: 'gr', name: 'Greece Flag' },
    { abbreviation: 'gs', name: 'South Georgia and the South Sandwich Islands Flag' },
    { abbreviation: 'gt', name: 'Guatemala Flag' },
    { abbreviation: 'gu', name: 'Guam Flag' },
    { abbreviation: 'gw', name: 'Guinea-Bissau Flag' },
    { abbreviation: 'gy', name: 'Guyana Flag' },
    { abbreviation: 'hk', name: 'Hong Kong Flag' },
    { abbreviation: 'hn', name: 'Honduras Flag' },
    { abbreviation: 'hr', name: 'Croatia Flag' },
    { abbreviation: 'ht', name: 'Haiti Flag' },
    { abbreviation: 'hu', name: 'Hungary Flag' },
    { abbreviation: 'id', name: 'Indonesia Flag' },
    { abbreviation: 'ie', name: 'Ireland Flag' },
    { abbreviation: 'il', name: 'Israel Flag' },
    { abbreviation: 'im', name: 'Isle of Man Flag' },
    { abbreviation: 'io', name: 'British Indian Ocean Territory Flag' },
    { abbreviation: 'iq', name: 'Iraq Flag' },
    { abbreviation: 'ir', name: 'Iran (Islamic Republic of) Flag' },
    { abbreviation: 'is', name: 'Iceland Flag' },
    { abbreviation: 'it', name: 'Italy Flag' },
    { abbreviation: 'je', name: 'Jersey Flag' },
    { abbreviation: 'jm', name: 'Jamaica Flag' },
    { abbreviation: 'jo', name: 'Jordan Flag' },
    { abbreviation: 'jp', name: 'Japan Flag' },
    { abbreviation: 'ke', name: 'Kenya Flag' },
    { abbreviation: 'kg', name: 'Kyrgyzstan Flag' },
    { abbreviation: 'kh', name: 'Cambodia Flag' },
    { abbreviation: 'ki', name: 'Kiribati Flag' },
    { abbreviation: 'km', name: 'Comoros Flag' },
    { abbreviation: 'kn', name: 'Saint Kitts and Nevis Flag' },
    { abbreviation: 'kp', name: 'North Korea Flag' },
    { abbreviation: 'kr', name: 'South Korea Flag' },
    { abbreviation: 'kw', name: 'Kuwait Flag' },
    { abbreviation: 'ky', name: 'Cayman Islands Flag' },
    { abbreviation: 'kz', name: 'Kazakhstan Flag' },
    { abbreviation: 'la', name: 'Laos Flag' },
    { abbreviation: 'lb', name: 'Lebanon Flag' },
    { abbreviation: 'lc', name: 'Saint Lucia Flag' },
    { abbreviation: 'li', name: 'Liechtenstein Flag' },
    { abbreviation: 'lk', name: 'Sri Lanka Flag' },
    { abbreviation: 'lr', name: 'Liberia Flag' },
    { abbreviation: 'ls', name: 'Lesotho Flag' },
    { abbreviation: 'lt', name: 'Lithuania Flag' },
    { abbreviation: 'lu', name: 'Luxembourg Flag' },
    { abbreviation: 'lv', name: 'Latvia Flag' },
    { abbreviation: 'ly', name: 'Libya Flag' },
    { abbreviation: 'ma', name: 'Morocco Flag' },
    { abbreviation: 'mc', name: 'Monaco Flag' },
    { abbreviation: 'md', name: 'Moldova Flag' },
    { abbreviation: 'me', name: 'Montenegro Flag' },
    { abbreviation: 'mf', name: 'Saint Martin Flag' },
    { abbreviation: 'mg', name: 'Madagascar Flag' },
    { abbreviation: 'mh', name: 'Marshall Islands Flag' },
    { abbreviation: 'mk', name: 'Former Yugoslav Republic of Macedonia Flag' },
    { abbreviation: 'ml', name: 'Mali Flag' },
    { abbreviation: 'mm', name: 'Myanmar Flag' },
    { abbreviation: 'mn', name: 'Mongolia Flag' },
    { abbreviation: 'mo', name: 'Macau Flag' },
    { abbreviation: 'mp', name: 'Northern Mariana Islands Flag' },
    { abbreviation: 'mq', name: 'Martinique Flag' },
    { abbreviation: 'mr', name: 'Mauritania Flag' },
    { abbreviation: 'ms', name: 'Montserrat Flag' },
    { abbreviation: 'mt', name: 'Malta Flag' },
    { abbreviation: 'mu', name: 'Mauritius Flag' },
    { abbreviation: 'mv', name: 'Maldives Flag' },
    { abbreviation: 'mw', name: 'Malawi Flag' },
    { abbreviation: 'mx', name: 'Mexico Flag' },
    { abbreviation: 'my', name: 'Malaysia Flag' },
    { abbreviation: 'mz', name: 'Mozambique Flag' },
    { abbreviation: 'na', name: 'Namibia Flag' },
    { abbreviation: 'nc', name: 'New Caledonia Flag' },
    { abbreviation: 'ne', name: 'Niger Flag' },
    { abbreviation: 'nf', name: 'Norfolk Island Flag' },
    { abbreviation: 'ng', name: 'Nigeria Flag' },
    { abbreviation: 'ni', name: 'Nicaragua Flag' },
    { abbreviation: 'nl', name: 'Netherlands Flag' },
    { abbreviation: 'no', name: 'Norway Flag' },
    { abbreviation: 'np', name: 'Nepal Flag' },
    { abbreviation: 'nr', name: 'Nauru Flag' },
    { abbreviation: 'nu', name: 'Niue Flag' },
    { abbreviation: 'nz', name: 'New Zealand Flag' },
    { abbreviation: 'om', name: 'Oman Flag' },
    { abbreviation: 'pa', name: 'Panama Flag' },
    { abbreviation: 'pe', name: 'Peru Flag' },
    { abbreviation: 'pf', name: 'French Polynesia Flag' },
    { abbreviation: 'pg', name: 'Papua New Guinea Flag' },
    { abbreviation: 'ph', name: 'Philippines Flag' },
    { abbreviation: 'pk', name: 'Pakistan Flag' },
    { abbreviation: 'pl', name: 'Poland Flag' },
    { abbreviation: 'pm', name: 'Saint Pierre and Miquelon Flag' },
    { abbreviation: 'pn', name: 'Pitcairn Flag' },
    { abbreviation: 'pr', name: 'Puerto Rico Flag' },
    { abbreviation: 'ps', name: 'State of Palestine Flag' },
    { abbreviation: 'pt', name: 'Portugal Flag' },
    { abbreviation: 'pw', name: 'Palau Flag' },
    { abbreviation: 'py', name: 'Paraguay Flag' },
    { abbreviation: 'qa', name: 'Qatar Flag' },
    { abbreviation: 're', name: 'Réunion Flag' },
    { abbreviation: 'ro', name: 'Romania Flag' },
    { abbreviation: 'rs', name: 'Serbia Flag' },
    { abbreviation: 'ru', name: 'Russia Flag' },
    { abbreviation: 'rw', name: 'Rwanda Flag' },
    { abbreviation: 'sa', name: 'Saudi Arabia Flag' },
    { abbreviation: 'sb', name: 'Solomon Islands Flag' },
    { abbreviation: 'sc', name: 'Seychelles Flag' },
    { abbreviation: 'sd', name: 'Sudan Flag' },
    { abbreviation: 'se', name: 'Sweden Flag' },
    { abbreviation: 'sg', name: 'Singapore Flag' },
    { abbreviation: 'sh', name: 'Saint Helena, Ascension and Tristan da Cunha Flag' },
    { abbreviation: 'si', name: 'Slovenia Flag' },
    { abbreviation: 'sj', name: 'Svalbard and Jan Mayen Flag' },
    { abbreviation: 'sk', name: 'Slovakia Flag' },
    { abbreviation: 'sl', name: 'Sierra Leone Flag' },
    { abbreviation: 'sm', name: 'San Marino Flag' },
    { abbreviation: 'sn', name: 'Senegal Flag' },
    { abbreviation: 'so', name: 'Somalia Flag' },
    { abbreviation: 'sr', name: 'Suriname Flag' },
    { abbreviation: 'ss', name: 'South Sudan Flag' },
    { abbreviation: 'st', name: 'Sao Tome and Principe Flag' },
    { abbreviation: 'sv', name: 'El Salvador Flag' },
    { abbreviation: 'sx', name: 'Sint Maarten Flag' },
    { abbreviation: 'sy', name: 'Syrian Arab Republic Flag' },
    { abbreviation: 'sz', name: 'Swaziland Flag' },
    { abbreviation: 'tc', name: 'Turks and Caicos Islands Flag' },
    { abbreviation: 'td', name: 'Chad Flag' },
    { abbreviation: 'tf', name: 'French Southern Territories Flag' },
    { abbreviation: 'tg', name: 'Togo Flag' },
    { abbreviation: 'th', name: 'Thailand Flag' },
    { abbreviation: 'tj', name: 'Tajikistan Flag' },
    { abbreviation: 'tk', name: 'Tokelau Flag' },
    { abbreviation: 'tl', name: 'Timor-Leste Flag' },
    { abbreviation: 'tm', name: 'Turkmenistan Flag' },
    { abbreviation: 'tn', name: 'Tunisia Flag' },
    { abbreviation: 'to', name: 'Tonga Flag' },
    { abbreviation: 'tr', name: 'Turkey Flag' },
    { abbreviation: 'tt', name: 'Trinidad and Tobago Flag' },
    { abbreviation: 'tv', name: 'Tuvalu Flag' },
    { abbreviation: 'tw', name: 'Taiwan Flag' },
    { abbreviation: 'tz', name: 'Tanzania Flag' },
    { abbreviation: 'ua', name: 'Ukraine Flag' },
    { abbreviation: 'ug', name: 'Uganda Flag' },
    { abbreviation: 'um', name: 'United States Minor Outlying Islands Flag' },
    { abbreviation: 'us', name: 'United States of America Flag' },
    { abbreviation: 'uy', name: 'Uruguay Flag' },
    { abbreviation: 'uz', name: 'Uzbekistan Flag' },
    { abbreviation: 'va', name: 'Holy See Flag' },
    { abbreviation: 'vc', name: 'Saint Vincent and the Grenadines Flag' },
    { abbreviation: 've', name: 'Venezuela (Bolivarian Republic of) Flag' },
    { abbreviation: 'vg', name: 'Virgin Islands (British) Flag' },
    { abbreviation: 'vi', name: 'Virgin Islands (U.S.) Flag' },
    { abbreviation: 'vn', name: 'Vietnam Flag' },
    { abbreviation: 'vu', name: 'Vanuatu Flag' },
    { abbreviation: 'wf', name: 'Wallis and Futuna Flag' },
    { abbreviation: 'ws', name: 'Samoa Flag' },
    { abbreviation: 'ye', name: 'Yemen Flag' },
    { abbreviation: 'yt', name: 'Mayotte Flag' },
    { abbreviation: 'za', name: 'South Africa Flag' },
    { abbreviation: 'zm', name: 'Zambia Flag' },
    { abbreviation: 'zw', name: 'Zimbabwe Flag' },
  ];